module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/xanthomonas_pimiento/preventiva/vacciplant.png
// module id = 2212
// module chunks = 3